import { render, staticRenderFns } from "./sela_castle_introduce.vue?vue&type=template&id=9826114e&scoped=true"
import script from "./sela_castle_introduce.vue?vue&type=script&lang=js"
export * from "./sela_castle_introduce.vue?vue&type=script&lang=js"
import style0 from "./sela_castle_introduce.vue?vue&type=style&index=0&id=9826114e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../makeup-web/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9826114e",
  null
  
)

export default component.exports